// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import colors from '@tcp/core/styles/themes/TCP/colors';
import { getIconPath } from '@tcp/core/src/utils';

export default css`
  &.featured-products-desktop {
    .feature-product-header {
      font-weight: bold;
      font-size: ${(props) => props.theme.typography.fontSizes.fs20};
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      margin-bottom: 24px;
      line-height: 27px;
      ${(props) => !props.featuredProductList?.length && `display:none;`}
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs14};
        line-height: 20px;
        margin-bottom: 18px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs16};
        margin-bottom: 16px;
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        min-width: 229px;
      }
      @media ${(props) => props.theme.mediaQuery.desktop} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs24};
        width: auto;
      }
    }
    .feature-product-header.redesign {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      min-width: 0;
      @media ${(props) => props.theme.mediaQuery.large} {
        margin-bottom: 16px;
      }
    }
    .view-all-heading-wrapper {
      display: flex;
      ${(props) => !props.featuredProductList?.length && `display:none;`}
    }
    .view-all-heading-wrapper.redesign {
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        justify-content: space-between;
      }
    }
    .view-all-link {
      margin-left: 20px;
      color: ${colors.BUTTON.BLUE.LEFT_FILTERS_BTN};
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      line-height: 24px;
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        line-height: 20px;
      }
    }
    .view-all-link.redesign {
      margin-left: 16px;
      color: ${(props) => props.theme.colors.BLACK};
      font-weight: 400;
    }
    .view-all-right-arrow {
      width: 15px;
      height: 10px;
      margin-left: 5px;
    }
    .product-tile-wrapper {
      margin: 0px 39px 20px;

      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        margin: 0px 12px 20px;
      }
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        margin: 0px 18px 20px;
      }
    }
    .product-tile-wrapper:nth-child(1) {
      margin-left: 0px;
    }
    .ratings-container {
      @media ${(props) => props.theme.mediaQuery.medium} {
        min-height: 23px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        height: 0px;
      }
    }
    .featured-products-grid {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: nowrap;

      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        flex-wrap: nowrap;
        width: 100%;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 20px;
        overflow-y: hidden;
      }
    }
    .slick-prev,
    .slick-next {
      top: 40%;
      z-index: 100;
    }
    .slick-track {
      margin-left: 16px;
    }
    .slick-next {
      width: 18px;
      height: 21px;
      padding: 15px;
      background: url(${(props) => getIconPath('right-arrow', props)}) no-repeat center center;
      border-radius: 100%;
      right: -14px;
    }
    .slick-prev {
      background: url(${(props) => getIconPath('right-arrow', props)}) no-repeat center center;
      border-radius: 100%;
      padding: 15px;
      left: -14px;
    }
  }
  &.featured-products-desktop.featured-auto-suggest {
    .featured-products-grid {
      justify-content: space-between;
      padding-right: 0;
    }
    .product-tile-wrapper:nth-child(2),
    .product-tile-wrapper:nth-child(5) {
      margin-left: 0px;
      margin-right: 0px;
    }
  }
`;
